import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import {
  QuoteInfoTab,
  QuoteLineInternalType,
} from '../../types/state/quote-line';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

type Params = QuoteLineParams & {
  tab: QuoteInfoTab.QuoteHistory | QuoteInfoTab.OrderHistory;
  customerOnly?: boolean;
};

const tabToStateVariableMap: Record<
  QuoteInfoTab.QuoteHistory | QuoteInfoTab.OrderHistory,
  keyof Pick<
    QuoteLineInternalType,
    | 'infoTabQuoteHistoryFilterByCustomer'
    | 'infoTabOrderHistoryFilterByCustomer'
  >
> = {
  [QuoteInfoTab.QuoteHistory]: 'infoTabQuoteHistoryFilterByCustomer',
  [QuoteInfoTab.OrderHistory]: 'infoTabOrderHistoryFilterByCustomer',
};

export function quoteLineInfoCustomerOnlyToggled(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const { customerOnly } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  if (customerOnly === undefined) {
    quoteLine[tabToStateVariableMap[action.payload.tab]] =
      !quoteLine[tabToStateVariableMap[action.payload.tab]];
  } else {
    quoteLine[tabToStateVariableMap[action.payload.tab]] = customerOnly;
  }
}
